import React, {useState} from 'react';
import CustomButton from 'components/customButton';
import Modal from 'components/modal';
import {useAuth} from 'context/authContext';
import {ReactComponent as ReactLogo} from 'assets/images/exit/exit.svg';
import {useNavigate} from 'react-router-dom';
const ExitUser = () => {
  const navigate = useNavigate();
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const {logout} = useAuth();
  const handleClick = () => {
    logout();
    navigate('/auth/login');
  };

  return (
    <>
      <div
        className="flex gap-4 text-medium text-[16px] items-center leading-[20px] text-black"
        onClick={() => setIsOpenModal(prev => !prev)}
      >
        <ReactLogo />
        <small className=" text-medium text-[16px] items-center leading-[20px] text-black">
          خروج از حساب کاربری
        </small>
      </div>
      <Modal setIsOpen={setIsOpenModal} isOpen={isOpenModal}>
        <div className="flex w-full flex-col gap-4  bg-white  p-4 rounded-lg">
          <div className="flex w-full flex-col gap-4">
            <div className="flex flex-col w-full justify-center items-center gap-6">
              <div className="w-full text-gray-5 font-medium text-18px">
                آیا اطمینان به خروج از حساب کاربری خود دارید؟
              </div>
              <div className="flex w-full items-center  gap-4">
                <CustomButton
                  className="!bg-white  !text-red-1 !w-[50%]"
                  type="button"
                  title="انصراف"
                  onClick={() => setIsOpenModal(false)}
                />
                <CustomButton
                  className="!bg-error  !text-white !w-[50%]"
                  type="button"
                  title="بله"
                  onClick={() => handleClick()}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ExitUser;
